module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_seasons-pick-bd19d555f82fe45dcde9ee474100d61e.jpg";